import React from 'react';
import { oneOf, object } from 'prop-types';
import { connect } from 'react-redux';
import { Radio } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { CHECKOUT_PLANS } from '../../../../../../../utils/packagesUtils/constants';
import { MP_CHANGED_CHECKOUT_PLAN } from '../../../../../../../utils/mixPanelEvents';
import { PACKAGE_POSITIONS } from '../../../../../../../types/packagePositions';
import { CHECKOUT_PLAN_RADIO } from '../constants';
import { selectCheckoutPlan } from '../../../../../../../actions/packages';
import { getSelectedCheckoutPlan } from '../../../../../../../reducers/packages';

import './style.scss';

const source = PACKAGE_POSITIONS.TABS;

const SingleOrderPlanRadio = (
    { selectedCheckoutPlan, selectCheckoutPlan },
    { biEvents }
) => {

    const onChange = () => {
        const selectedCheckoutPlan = CHECKOUT_PLANS.SINGLE_ORDER;

        reportChangeCheckoutPlan(selectedCheckoutPlan);

        selectCheckoutPlan({ selectedCheckoutPlan });
    };

    const reportChangeCheckoutPlan = (selectedCheckoutPlan) => {
        const params = { source, selectedCheckoutPlan };

        biEvents.sendMixPanelEvent({
            eventName: MP_CHANGED_CHECKOUT_PLAN,
            params
        });
    };

    return (
        <Radio className="single-order-plan-radio"
            name={CHECKOUT_PLAN_RADIO}
            checked={selectedCheckoutPlan === CHECKOUT_PLANS.SINGLE_ORDER}
            onChange={onChange}
            color={Radio.COLORS.GREEN}>
            <I18n k="gig_page_perseus.recurring.order_once"/>
        </Radio>
    );
};

SingleOrderPlanRadio.propTypes = {
    selectedCheckoutPlan: oneOf(Object.values(CHECKOUT_PLANS))
};

SingleOrderPlanRadio.contextTypes = {
    biEvents: object
};

const mapStateToProps = ({ packages }) => {
    const selectedCheckoutPlan = getSelectedCheckoutPlan(packages);

    return { selectedCheckoutPlan };
};

const mapDispatchToProps = { selectCheckoutPlan };

export { SingleOrderPlanRadio };
export default connect(mapStateToProps, mapDispatchToProps)(SingleOrderPlanRadio);
